import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
const validate = ({ value }) => {
    const res = {
        prefix: false,
        url: false,
    };
    if (!value) {
        return { ...res, isValid: false };
    }
    res.prefix = value.startsWith('http:') || value.startsWith('https:');
    try {
        new URL(value);
        res.url = true;
    }
    catch {
        res.url = false;
    }
    return { ...res, isValid: !Object.entries(res).some(([_, v]) => !v) };
};
export const useValidateURL = () => {
    return (params) => {
        const state = validate(params);
        const errors = [];
        if (!state.prefix) {
            errors.push(_jsx(FormattedMessage, { id: "validate-url.prefix" }));
        }
        if (!state.url) {
            errors.push(_jsx(FormattedMessage, { id: "validate-url.generic" }));
        }
        return { isValid: state.isValid, errors: errors.length ? errors : undefined };
    };
};
